<template>
  <div id="register" class="fill-height">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card class="elevation-0 pl-5 pr-5" tile :loading="CardLoading">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div v-if="!Submited">
                <v-card-title class="headline">{{ $t('register.create_your_organization') }}</v-card-title>

                <v-card-subtitle>Create your account</v-card-subtitle>
              </div>
            </div>
            <div>
              <form-register v-if="!Submited" @ToggleLoading="ToggleLoading" @SuccessRegister="SuccessRegister" :step="Step"></form-register>
              <div class="text-center ma-5" v-if="Submited">
                <h1>Account Registered Successfully</h1>
                <p>Email confirmation sent to {{SubmitedEmail}}</p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
// @ is an alias to /src
/*eslint no-console: "off"*/
import FormRegister from './FormRegister.vue';

export default {
  name: "home",
  data() {
    return {
      Step: 1,
      CardLoading: false,
      Submited: false,
      SubmitedEmail: ''
    };
  },
  components:{
    FormRegister
  },
  methods:{
    ToggleLoading: function(){
      this.CardLoading = !this.CardLoading;
    },
    SuccessRegister: function(values){
      this.Submited = true;
      console.log(values)
      this.SubmitedEmail = values.email
    }
  }
};
</script>
